"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getAssetsDistribution = exports.defaultAssetsDistribution = exports.getCurrencyPortfolio = exports.getPortfolio = exports.getBalanceHistoryWithCountervalue = exports.getBalanceHistory = exports.getBalanceHistoryJS = void 0;
var bignumber_js_1 = require("bignumber.js");
var memoize_1 = __importDefault(require("lodash/memoize"));
var last_1 = __importDefault(require("lodash/last"));
var find_1 = __importDefault(require("lodash/find"));
var operation_1 = require("../operation");
var helpers_1 = require("../account/helpers");
var env_1 = require("../env");
var range_1 = require("./range");
__exportStar(require("./range"), exports);
/**
 * generate an array of {daysCount} datapoints, one per day,
 * for the balance history of an account.
 * The last item of the array is the balance available right now.
 * @memberof account
 */
var getBalanceHistoryImpl = function (account, r) {
    var conf = (0, range_1.getPortfolioRangeConfig)(r);
    var history = [];
    var balance = account.balance;
    var operationsLength = account.operations.length;
    var i = 0; // index of operation
    var t = new Date();
    history.unshift({
        date: t,
        value: balance
    });
    t = new Date(conf.startOf(t) - 1); // end of yesterday
    for (var d = conf.count - 1; d > 0; d--) {
        // accumulate operations after time t
        while (i < operationsLength && account.operations[i].date > t) {
            balance = balance.minus((0, operation_1.getOperationAmountNumberWithInternals)(account.operations[i]));
            i++;
        }
        if (i === operationsLength) {
            // When there is no more operation, we consider we reached ZERO to avoid invalid assumption that balance was already available.
            balance = new bignumber_js_1.BigNumber(0);
        }
        history.unshift({
            date: t,
            value: bignumber_js_1.BigNumber.max(balance, 0)
        });
        t = new Date(t - conf.increment);
    }
    return history;
};
var accountRateHash = function (account, r) {
    return "".concat(r, "_").concat(account.id, "_").concat(account.balance.toString(), "_").concat(account.operations[0] ? account.operations[0].id : "");
};
exports.getBalanceHistoryJS = (0, memoize_1["default"])(getBalanceHistoryImpl, accountRateHash);
var getBalanceHistory = function (account, r) {
    // try to find it in the account object
    var balanceHistory = account.balanceHistory;
    if (balanceHistory &&
        balanceHistory[r] &&
        balanceHistory[r].length > 1) {
        return balanceHistory[r];
    }
    // fallback on JS implementation
    return (0, exports.getBalanceHistoryJS)(account, r);
};
exports.getBalanceHistory = getBalanceHistory;
// hash the "stable" part of the histo
// only the latest datapoint is "unstable" meaning it always changes because it's the current date.
var accountRateHashCVStable = function (account, r, cvRef, useEffectiveFrom) {
    return "".concat(accountRateHash(account, r), "_").concat(cvRef ? cvRef.toString() : "none", "_").concat(useEffectiveFrom ? "withEffectiveFrom" : "");
};
var accountCVstableCache = {};
var ZERO = new bignumber_js_1.BigNumber(0);
var percentageHighThreshold = 100000;
var meaningfulPercentage = function (deltaChange, balanceDivider) {
    if (deltaChange && balanceDivider && !balanceDivider.isZero()) {
        var percent = deltaChange.div(balanceDivider);
        if (percent.lt(percentageHighThreshold)) {
            return percent;
        }
    }
};
var getBalanceHistoryWithCountervalue = function (account, r, calc, useEffectiveFrom) {
    if (useEffectiveFrom === void 0) { useEffectiveFrom = true; }
    var history = (0, exports.getBalanceHistory)(account, r);
    var cur = (0, helpers_1.getAccountCurrency)(account);
    // a high enough value so we can compare if something changes
    var cacheReferenceValue = new bignumber_js_1.BigNumber("10").pow(3 + cur.units[0].magnitude);
    // pick a stable countervalue point in time to hash for the cache
    var cvRef = calc(cur, cacheReferenceValue, history[0].date);
    var mapFn = function (p) { return (__assign(__assign({}, p), { countervalue: (cvRef && calc(cur, p.value, p.date)) || ZERO })); };
    var stableHash = accountRateHashCVStable(account, r, cvRef, useEffectiveFrom);
    var stable = accountCVstableCache[stableHash];
    var lastPoint = mapFn(history[history.length - 1]);
    var calcChanges = function (h) {
        // previous existing implementation here
        var from = h[0];
        var to = h[h.length - 1];
        var fromEffective = useEffectiveFrom
            ? (0, find_1["default"])(h, function (record) { return record.value.isGreaterThan(0); }) || from
            : from;
        return {
            countervalueReceiveSum: new bignumber_js_1.BigNumber(0),
            // not available here
            countervalueSendSum: new bignumber_js_1.BigNumber(0),
            cryptoChange: {
                value: to.value.minus(fromEffective.value),
                percentage: null
            },
            countervalueChange: {
                value: (to.countervalue || ZERO).minus(fromEffective.countervalue || ZERO),
                percentage: meaningfulPercentage((to.countervalue || ZERO).minus(fromEffective.countervalue || ZERO), fromEffective.countervalue)
            }
        };
    };
    if (!stable) {
        var h_1 = history.map(mapFn);
        stable = __assign({ history: h_1, countervalueAvailable: !!cvRef }, calcChanges(h_1));
        accountCVstableCache[stableHash] = stable;
        return stable;
    }
    var lastStable = (0, last_1["default"])(stable.history);
    if (lastPoint.countervalue.eq(lastStable.countervalue)) {
        return stable;
    }
    var h = stable.history.slice(0, -1).concat(lastPoint);
    var copy = __assign(__assign(__assign({}, stable), { history: h }), calcChanges(h));
    accountCVstableCache[stableHash] = copy;
    return copy;
};
exports.getBalanceHistoryWithCountervalue = getBalanceHistoryWithCountervalue;
/**
 * calculate the total balance history for all accounts in a reference fiat unit
 * and using a CalculateCounterValue function (see countervalue helper)
 * NB the last item of the array is actually the current total balance.
 * @memberof account
 */
function getPortfolio(topAccounts, range, calc) {
    var accounts = (0, helpers_1.flattenAccounts)(topAccounts);
    var availableAccounts = [];
    var unavailableAccounts = [];
    var histories = [];
    var changes = [];
    var countervalueReceiveSums = [];
    var countervalueSendSums = [];
    for (var i = 0; i < accounts.length; i++) {
        var account = accounts[i];
        var r = (0, exports.getBalanceHistoryWithCountervalue)(account, range, calc, false);
        if (r.countervalueAvailable) {
            availableAccounts.push(account);
            histories.push(r.history);
            changes.push(r.countervalueChange.value);
            countervalueReceiveSums.push(r.countervalueReceiveSum);
            countervalueSendSums.push(r.countervalueSendSum);
        }
        else {
            unavailableAccounts.push(account);
        }
    }
    var unavailableCurrencies = __spreadArray([], __read(new Set(unavailableAccounts.map(helpers_1.getAccountCurrency))), false);
    var balanceAvailable = accounts.length === 0 || availableAccounts.length > 0;
    var balanceHistory = (0, range_1.getDates)(range).map(function (date) { return ({
        date: date,
        value: ZERO
    }); });
    for (var i = 0; i < histories.length; i++) {
        var history_1 = histories[i];
        for (var j = 0; j < history_1.length; j++) {
            var res = balanceHistory[j];
            if (res) {
                res.value = res.value.plus(history_1[j].countervalue);
            }
        }
    }
    var countervalueChangeValue = changes.reduce(function (sum, v) { return sum.plus(v); }, new bignumber_js_1.BigNumber(0));
    var countervalueReceiveSum = countervalueReceiveSums.reduce(function (sum, v) { return sum.plus(v); }, new bignumber_js_1.BigNumber(0));
    var countervalueSendSum = countervalueSendSums.reduce(function (sum, v) { return sum.plus(v); }, new bignumber_js_1.BigNumber(0));
    // in case there were no receive, we just track the market change
    // weighted by the current balances
    var countervalueChangePercentage;
    if ((0, env_1.getEnv)("EXPERIMENTAL_ROI_CALCULATION")) {
        if (countervalueReceiveSum.isZero()) {
            countervalueChangePercentage = meaningfulPercentage(countervalueChangeValue, balanceHistory[0].value.plus(countervalueSendSum));
        }
        else {
            countervalueChangePercentage = meaningfulPercentage(countervalueChangeValue, countervalueReceiveSum);
        }
    }
    else {
        countervalueChangePercentage = meaningfulPercentage(countervalueChangeValue, // in non experimental mode, we were dividing by first point
        balanceHistory[0].value);
    }
    var ret = {
        balanceHistory: balanceHistory,
        balanceAvailable: balanceAvailable,
        availableAccounts: availableAccounts,
        unavailableCurrencies: unavailableCurrencies,
        accounts: accounts,
        range: range,
        histories: histories,
        countervalueReceiveSum: countervalueReceiveSum,
        countervalueSendSum: countervalueSendSum,
        countervalueChange: {
            percentage: countervalueChangePercentage,
            value: countervalueChangeValue
        }
    };
    return ret;
}
exports.getPortfolio = getPortfolio;
/**
 * calculate the total balance history for all accounts in a reference fiat unit
 * and using a CalculateCounterValue function (see countervalue helper)
 * NB the last item of the array is actually the current total balance.
 * @memberof account
 */
function getCurrencyPortfolio(accounts, range, calc) {
    var histories = [];
    var countervalueAvailable = false;
    for (var i = 0; i < accounts.length; i++) {
        var account = accounts[i];
        var r = (0, exports.getBalanceHistoryWithCountervalue)(account, range, calc);
        histories.push(r.history);
        countervalueAvailable = r.countervalueAvailable;
    }
    var history = (0, range_1.getDates)(range).map(function (date) { return ({
        date: date,
        value: ZERO,
        countervalue: ZERO
    }); });
    for (var i = 0; i < histories.length; i++) {
        var h = histories[i];
        for (var j = 0; j < h.length; j++) {
            var res = history[j];
            res.value = res.value.plus(h[j].value);
            res.countervalue = res.countervalue.plus(h[j].countervalue);
        }
    }
    // previous existing implementation here
    var from = history[0];
    var to = history[history.length - 1];
    var fromEffective = (0, find_1["default"])(history, function (record) { return record.value.isGreaterThan(0); }) || from;
    var cryptoChange = {
        value: to.value.minus(from.value),
        percentage: null
    };
    var countervalueChange = {
        value: (to.countervalue || ZERO).minus(fromEffective.countervalue || ZERO),
        percentage: meaningfulPercentage((to.countervalue || ZERO).minus(fromEffective.countervalue || ZERO), fromEffective.countervalue)
    };
    var ret = {
        history: history,
        countervalueAvailable: countervalueAvailable,
        accounts: accounts,
        range: range,
        histories: histories,
        cryptoChange: cryptoChange,
        countervalueChange: countervalueChange
    };
    return ret;
}
exports.getCurrencyPortfolio = getCurrencyPortfolio;
exports.defaultAssetsDistribution = {
    minShowFirst: 1,
    maxShowFirst: 6,
    showFirstThreshold: 0.95
};
var assetsDistributionNotAvailable = {
    isAvailable: false,
    list: [],
    showFirst: 0,
    sum: new bignumber_js_1.BigNumber(0)
};
var previousDistributionCache = {
    hash: "",
    data: assetsDistributionNotAvailable
};
function getAssetsDistribution(topAccounts, calculateCountervalue, opts) {
    var _a = __assign(__assign({}, exports.defaultAssetsDistribution), opts), minShowFirst = _a.minShowFirst, maxShowFirst = _a.maxShowFirst, showFirstThreshold = _a.showFirstThreshold;
    var sum = new bignumber_js_1.BigNumber(0);
    var idBalances = {};
    var idCurrencies = {};
    var accounts = (0, helpers_1.flattenAccounts)(topAccounts);
    for (var i_1 = 0; i_1 < accounts.length; i_1++) {
        var account = accounts[i_1];
        var cur = (0, helpers_1.getAccountCurrency)(account);
        var id = cur.id;
        if (account.balance.isGreaterThan(0)) {
            idCurrencies[id] = cur;
            idBalances[id] = (idBalances[id] || new bignumber_js_1.BigNumber(0)).plus(account.balance);
        }
    }
    var idCountervalues = {};
    for (var id in idBalances) {
        var countervalue = calculateCountervalue(idCurrencies[id], idBalances[id]);
        if (countervalue) {
            idCountervalues[id] = countervalue;
            sum = sum.plus(countervalue);
        }
    }
    var idCurrenciesKeys = Object.keys(idCurrencies);
    if (idCurrenciesKeys.length === 0) {
        return assetsDistributionNotAvailable;
    }
    var isAvailable = !sum.isZero();
    var hash = "".concat(idCurrenciesKeys.length, "_").concat(sum.toString());
    if (hash === previousDistributionCache.hash) {
        return previousDistributionCache.data;
    }
    var list = idCurrenciesKeys
        .map(function (id) {
        var currency = idCurrencies[id];
        var amount = idBalances[id];
        var countervalue = idCountervalues[id] || new bignumber_js_1.BigNumber(0);
        return {
            currency: currency,
            countervalue: countervalue,
            amount: amount,
            distribution: isAvailable ? countervalue.div(sum).toNumber() : 0
        };
    })
        .sort(function (a, b) {
        var diff = b.countervalue.minus(a.countervalue).toNumber();
        if (diff === 0)
            return a.currency.name.localeCompare(b.currency.name);
        return diff;
    });
    var i;
    var acc = 0;
    for (i = 0; i < maxShowFirst && i < list.length; i++) {
        if (acc > showFirstThreshold) {
            break;
        }
        acc += list[i].distribution;
    }
    var showFirst = Math.max(minShowFirst, i);
    var data = {
        isAvailable: isAvailable,
        list: list,
        showFirst: showFirst,
        sum: sum
    };
    previousDistributionCache.hash = hash;
    previousDistributionCache.data = data;
    return data;
}
exports.getAssetsDistribution = getAssetsDistribution;
//# sourceMappingURL=index.js.map